// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hrRequestTypeEntity from './entities/hr-request-type.json';
import hrRequestTypeMenu from '../pages/hr-request-type/menu.json';
import hrRequestTypeFullForm from '../pages/hr-request-type/forms/full.json';
import hrRequestTypeContextForm from '../pages/hr-request-type/forms/context.json';
import hrRequestTypeMiniForm from '../pages/hr-request-type/forms/mini.json';
import hrRequestTypeLookupForm from '../pages/hr-request-type/forms/lookup.json';
import hrRequestTypeTableView from '../pages/hr-request-type/views/table.json';
import hrRequestTypeDashboardView from '../pages/hr-request-type/views/dashboard.json';

/** Тип запису «Тип кадрової заявки» зі сторінками пакета: меню, форми та подання з pages/hr-request-type/. */
export const hrRequestTypeDefinition: IRecordTypeDefinition = {
  ...hrRequestTypeEntity,
  views: assembleViewSet({
      table: hrRequestTypeTableView,
      dashboard: hrRequestTypeDashboardView,
  }),
  form: hrRequestTypeFullForm,
  forms: { full: hrRequestTypeFullForm, context: hrRequestTypeContextForm, mini: hrRequestTypeMiniForm, lookup: hrRequestTypeLookupForm },
  menu: hrRequestTypeMenu,
} as IRecordTypeDefinition;
